"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { PRIVACY_POLICY, TERMS } from "routes";

const LINKS = [
  { href: TERMS, label: "Terms and Conditions" },
  { href: PRIVACY_POLICY, label: "Privacy Policy" },
];

export default function LegalNav() {
  const pathname = usePathname();

  return (
    <nav className="flex sticky top-[60px] z-30 bg-white items-center px-4 md:px-16 lg:px-20 gap-16 border-b border-gray-100 ">
      {LINKS.map(({ href, label }) => {
        const isActive = pathname === href;
        return (
          <Link
            key={href}
            href={href}
            aria-current={isActive ? "page" : undefined}
            className={`text-[14px]  ${
              isActive
                ? "text-[#282886] hover:opacity-90  font-semibold"
                : "text-primarytext hover:text-[#282886] transition-colors"
            }`}
          >
            <span
              className={`inline-block py-2.5 border-b-[3px] ${
                isActive ? "border-[#282886]" : "border-transparent"
              }`}
            >
              {label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}
